
export const COMMON_ABILITY = [
    {
        subject: "dashboard",
        action : "manage"
    },
    {
        subject: "reports",
        action : "manage"
    },
    {
        subject: "templates",
        action : "manage"
    },
    {
        subject: "stages",
        action : "manage"
    },
    {
        subject: "people",
        action : "read"
    },
    {
        subject: "settings",
        action : "manage"
    },
    {
        subject: "companies-details",
        action : "manage"
    },
    {
        subject: "tags",
        action : "manage"
    },
    {
        subject: "platforms",
        action : "manage"
    }
];

export const ADMIN_BASED_ABILITY = [
    {
        subject: "segments",
        action : "manage"
    },
    {
        subject: "life-cycle",
        action : "manage"
    },
    {
        subject: "users",
        action : "manage"
    },
    {
        subject: "health-scores",
        action : "manage"
    },
    {
        subject: "surveys",
        action : "manage"
    },
    {
        subject: "playbooks",
        action : "manage"
    },
    {
        subject: "calculated-metrics",
        action : "manage"
    },
    {
        subject: "plans",
        action : "manage"
    }
];

export const ADMIN_ABILITY = [
    ...ADMIN_BASED_ABILITY,
    ...COMMON_ABILITY,
    {
        subject: "companies",
        action : "read"
    },
    {
        subject: "companies",
        action : "manage"
    },
    {
        subject: "organizations",
        action : "manage"
    },
    {
        subject: "custom-fields",
        action : "manage"
    }
];
export const SUPERADMIN_ABILITY = [
    {
        subject: "organizations",
        action : "manage"
    }
];

export const ADMIN_CSM_ABILITY = [
    ...ADMIN_BASED_ABILITY,
    ...COMMON_ABILITY,
    {
        subject: "companies",
        action : "read"
    },
    {
        subject: "companies",
        action : "manage"
    }
];

export const ADMIN_SDR_ABILITY = [
    ...ADMIN_BASED_ABILITY,
    ...COMMON_ABILITY,
    {
        subject: "companies",
        action : "read"
    },
    {
        subject: "companies",
        action : "create"
    },
    {
        subject: "companies",
        action : "delete"
    }
];

export const CSM_ABILITY = [
    ...COMMON_ABILITY,
    {
        subject: "companies",
        action : "read"
    },
    {
        subject: "companies",
        action : "manage"
    }
];

export const SDR_ABILITY = [
    ...COMMON_ABILITY,
    {
        subject: "companies",
        action : "read"
    },
    {
        subject: "companies",
        action : "create"
    },
    {
        subject: "companies",
        action : "delete"
    }
];
